import {clamp, mapValues} from 'lodash';
import type {RgbColor, HexColor} from './colorTypes';

/**
 * @name rgbToHex
 * @description Converts an RGB object into a hex code
 */
export const rgbToHex = (rgb: RgbColor): HexColor => {
  const hexParts = mapValues(rgb, (value, key) => {
    if (typeof value !== 'number') {
      if (key === 'a') {
        return null;
      } else {
        throw new Error(`Invalid RGB value: ${JSON.stringify(rgb)}`);
      }
    }

    let hexValue: number | string = clamp(
      value * (key === 'a' ? 255 : 1),
      0,
      255
    );
    hexValue = Math.round(hexValue).toString(16);

    return hexValue.length === 1 ? `0${hexValue}` : hexValue;
  });

  return `#${hexParts.r}${hexParts.g}${hexParts.b}${hexParts.a || ''}`;
};
